var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notice"},[_vm._v("\n        "+_vm._s(_vm._f("capitalize")(_vm.$t('please refresh your page')))+"\n    ")]),_vm._v(" "),_c('Illustration',{attrs:{"xl":"","image":"/static/img/illustrations/ticket__purchase-maintenance.svg"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dfb1267","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modals/modals/UnderMaintenance.vue
// module id = 2536
// module chunks = 0